import { Shell } from "../components/Shell";

/**
 * Route stubs.
 *
 * These exist so the router, the nav highlighting and keyboard navigation are
 * all real and testable now, rather than arriving together with content and
 * hiding each other's bugs. `/architecture` becomes the Failure Path diagram
 * at CP 10 and `/chat-stats` gets real numbers alongside the chat UI.
 */

export function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <Shell className="py-24">
      <p className="mb-2 font-mono text-2xs tracking-widest text-accent uppercase">
        Not built yet
      </p>
      <h1 className="mb-4 text-xl sm:text-2xl lg:text-3xl">{title}</h1>
      <p className="max-w-(--spacing-measure) text-text-dim">{note}</p>
    </Shell>
  );
}
